import { createSimpleCache, CreateSimpleCacheOptions } from 'app/shared/lib/cache/create-simple-cache';
import { Sorting } from 'app/shared/lib/essette-site';
import * as UM from 'app/um/models/essette-api';

export interface IDeterminationsCacheState {
    determinations: ReadonlyArray<UM.AuthDeterminationHistory>;
    determinationDetails: Record<string, { details: Array<object>, sorting?: Sorting }>;
    sorting?: Sorting;
    authId?: string;
}

export const createDeterminationsCache = (opts: CreateSimpleCacheOptions<IDeterminationsCacheState>) =>
    createSimpleCache<IDeterminationsCacheState>({ determinations: [], determinationDetails: {} }, opts);

export type IDeterminationsCache = ReturnType<typeof createDeterminationsCache>;
